module.exports = __webpack_public_path__ + "static/img/bg-banner-contackus.c55f615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-banner-contackus.png
// module id = UUHx
// module chunks = 1